import { isElement } from "./auth-service-tools1025.js";

function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

export { getDocumentElement as default };